import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20background%20with%20colorful%20gradient%20sky%2C%20silhouettes%20of%20multiple%20anime%20characters%20in%20dynamic%20action%20poses%2C%20glowing%20energy%20effects%2C%20motion%20lines%2C%20cinematic%20composition%2C%20warm%20orange%20and%20red%20tones%2C%20artistic%20illustration&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="51动漫官网 - 在线观看动漫"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/70"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <div className="flex items-center gap-3 mb-6 animate-fade-in-up">
          <div className="w-14 h-14 flex items-center justify-center bg-primary-500 rounded-2xl shadow-lg">
            <i className="ri-play-circle-fill text-white text-3xl"></i>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white">
            51动漫官网
          </h1>
        </div>
        <p className="text-base md:text-xl text-white/80 max-w-2xl mb-3 leading-relaxed animate-fade-in-up animate-delay-100">
          51动漫在线观看 · 51动漫下载 · 动漫全集免费追更
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mb-8 animate-fade-in-up animate-delay-200">
          涵盖日漫 · 韩漫 · 国漫 · 剧场版 | 支持下拉式阅读，沉浸式追番体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 animate-fade-in-up animate-delay-300">
          <Link
            to="/category/japanese"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-mini-fill mr-1.5"></i>立即观看
          </Link>
          <Link
            to="/category/chinese"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm backdrop-blur-sm transition-all cursor-pointer whitespace-nowrap border border-white/20"
          >
            <i className="ri-download-2-line mr-1.5"></i>动漫下载
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-10 animate-fade-in-up animate-delay-500">
          {[
            { num: "10,000+", label: "动漫资源" },
            { num: "50+", label: "日更新量" },
            { num: "500万+", label: "忠实用户" },
            { num: "10亿+", label: "累计播放" },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{stat.num}</div>
              <div className="text-xs md:text-sm text-white/50 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}